import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/visitor-dialogs")({
  component: lazyRouteComponent(() => import("./-pages/admin.visitor-dialogs")),
  head: () => ({ meta: [{ title: "Visitor Dialogs — Admin" }] }),
});
